export default __webpack_public_path__ + "static/media/17.8f428fa5.jpg";